import { PromiseReturnType } from "blitz"
import MyLoginForm from "src/app/auth/components/MyLoginForm"
import login from "src/app/auth/mutations/login"

type Props = {
  onSuccess?: (user: PromiseReturnType<typeof login>) => void
}

export const DashboardLoginPage = ({ onSuccess }: Props) => {
  return <MyLoginForm onSuccess={onSuccess} />
}
